import { combineReducers } from "redux";
import constants from "./constants";
import createApiReducer from "reducers/createReducers";

const reducers = combineReducers({
  getBusinessAccountResult: createApiReducer(constants.GET_BUSINESS_ACCOUNT, {}),
});

export default reducers;
